import { useMutation } from '@tanstack/react-query'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'

import { useDocumentReportId } from './useDocumentReportId'
import { useMainQueryData } from './useMainQuery'

const document = graphql(`
  query DocumentReportEditPage_GetDocumentReportUpdatedAt(
    $documentReportId: ID!
  ) {
    document(documentId: $documentReportId) {
      updatedAt
    }
  }
`)

export const useCheckConflictMutation = (
  options: MutationOptions<boolean, void> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const documentReportId = useDocumentReportId()
  const documentReport = useMainQueryData()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { documentReportId },
      })

      return result.document?.updatedAt !== documentReport?.updatedAt
    },
    ...options,
  })
}
